import { RectModule, ButtonModule, FitTextModule, FormFieldModule} from '@shared/components/games';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SchulteCorrectAnswerPreviewComponent } from './schulte-preview/schulte-answer-preview/schulte-answer-preview.component';
import { SchulteControllerComponent } from './schulte-controller/schulte-controller.component';
import { SchulteExamplePreviewComponent } from './schulte-preview/schulte-example-preview/schulte-example-preview.component';
import { SchulteParametersPreviewComponent } from './schulte-preview/schulte-parameters-preview/schulte-parameters-preview.component';
import { SchulteSettingsComponent } from './schulte-settings/schulte-settings.component';
import { EvenNumberOnlyDirective } from './schulte-settings/even-number-only.directive';
import { SchulteUserAnswerPreviewComponent } from './schulte-preview/schulte-user-answer-preview/schulte-user-answer-preview.component';
import { TranslateModule } from '@ngx-translate/core';
import { DotForDigitPipe } from '@shared/pipes/dot-for-digit/dot-for-digit.pipe';
import { SharedModule } from '@shared/shared.module';
import { AlphabetPickerModule } from '@shared/components/games/alphabet-picker/alphabet-picker.module';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import {MatTooltip} from "@angular/material/tooltip";

@NgModule({
  declarations: [
    SchulteControllerComponent,
    SchulteSettingsComponent,
    EvenNumberOnlyDirective,
    SchulteCorrectAnswerPreviewComponent,
    SchulteExamplePreviewComponent,
    SchulteParametersPreviewComponent,
    SchulteUserAnswerPreviewComponent,
  ],
  exports: [
    SchulteControllerComponent,
    SchulteSettingsComponent,
    SchulteCorrectAnswerPreviewComponent,
    SchulteExamplePreviewComponent,
    SchulteParametersPreviewComponent,
    SchulteUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      isolate: true,
    }),
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RectModule,
    FitTextModule,
    SharedModule,
    AlphabetPickerModule,
    GamesSharedModule,
    DimensionsListenerDirective,
    FormFieldModule,
    MatTooltip,
  ],
})
export class SchulteModule {}
